require('./style.less');

var Marionette = require('marionette');
require('extendJQuery'); //unselectable

module.exports = Marionette.ItemView.extend({
  id: 'esNAV',
  template: require('./template'),
	ui: {
		hitBtns:            '.hitNavbtn',
		activeHitNumber:    '.curESHit',
        numberHits:         '.nESHits',
        navBar:             '.esNAVBtns'
	},
    initialize: function() { //TODO: have as command ...
        var lCh = this.options.lCh;
        this.listenTo(lCh, 'navView:toggleHits',        this.hitsToggledCB);
        this.listenTo(lCh, 'navView:updateHitCount',    this.updateHitCount);
        this.listenTo(lCh, 'navView:update',            this.update);
        lCh.reply({
            navView: function() {
              return this;
            }
        }, this);
    },
	events: {
        'click @ui.hitBtns':  'hitButtonClick'
  },
    serializeData: function() {
        var nHits = this.model.getNumberOfHits();
        return {
          activeHitNumber: this.options.lCh.request('currentHitNumber'), //note: will be updated anyway, maybe unecessary
          numHits: nHits
        };
    },
    onRender: function() {
        this.$el.unselectable();
    },
    hitButtonClick: function(e) {
        this.options.lCh.command('hitButtonClick', $(e.currentTarget).attr('title') );
    },
    hitsToggledCB: function(show) {
        this.$el.toggleClass('noOpacity', !show);
    },
    updateHitCount: function(hitPosition) {
        this.ui.activeHitNumber.text(hitPosition + 1);
    },
    /* update the activeHitNumber and the total number of hits */
    update: function(activeHitPosition, totalHits ) {
        this.updateHitCount(activeHitPosition);
        this.ui.numberHits.text(totalHits);
        //'no results found' replaces this on search w/ no results -- if there are none
        this.$el.toggleClass('hide', totalHits === 0);
        //TODO: may also want to toggle the 'grep button'
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/footer/navBar/view.js
 ** module id = 535
 ** module chunks = 0
 **/